<template>
  <div class="vz-order-payer-segregated mini">
    <div
      v-for="(item, index) of services"
      :key="index"
      class="vz-order-payer-segregated-row"
    >
      <div
        class="vz-order-payer-segregated-row-title"
      >
        <span>{{ item.title }}</span>
        <span>{{ item.cost }} {{ currencyMeasure }}</span>
      </div>
      <div class="vz-order-payer-segregated-row-column mt-10  ml-0" @click="onChangeSegregatedPayer(getItem('dispatch', item))">
        <vz-radiogroup
          v-model="item.payer"
          :disabled="item.disabled"
          :items="dispatch"
        />
      </div>
      <div class="vz-order-payer-segregated-row-column mt-10 ml-0" @click="onChangeSegregatedPayer(getItem('destination', item))">
        <vz-radiogroup
          v-model="item.payer"
          :disabled="item.disabled"
          :items="destination"
        />

      </div>
      <div class="vz-order-payer-segregated-row-column mt-10  ml-0" @click="onChangeSegregatedPayer(getItem('third', item))">
        <vz-radiogroup
          v-model="item.payer"
          :disabled="item.disabled"
          :items="third"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useSegregatedPayer from '~/components/personal/order/payer/useSegregatedPayer';
import {VzRadioGroupItem} from '~/types/types';

const { currencyMeasure, onChangeSegregatedPayer, services } = useSegregatedPayer()

const dispatch: VzRadioGroupItem[] = [{
  title: 'Отправитель',
  value: 'dispatch'
}]

const destination: VzRadioGroupItem[] = [{
  title: 'Получатель',
  value: 'destination'
}]

const third: VzRadioGroupItem[] = [{
  title: 'Третье лицо',
  value: 'third'
}]

function getItem(val, service) {
  return {
    guid: service.guid,
    value: val
  }
}
</script>
